import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _awaitAsyncGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/awaitAsyncGenerator";
import _wrapAsyncGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/wrapAsyncGenerator";
import _asyncIterator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncIterator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(sync);

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator";
import { isAsyncIterable, isIterable } from "../_internal/utils.js";
import concurrent, { isConcurrent } from "./concurrent.js";
import pipe1 from "../pipe1.js";
import { AsyncFunctionException } from "../_internal/error.js";

function asyncSequential(_x, _x2) {
  return _asyncSequential.apply(this, arguments);
}

function _asyncSequential() {
  _asyncSequential = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(f, iterable) {
    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator2, _step, item;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context.prev = 2;
            _iterator2 = _asyncIterator(iterable);

          case 4:
            _context.next = 6;
            return _awaitAsyncGenerator(_iterator2.next());

          case 6:
            if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
              _context.next = 16;
              break;
            }

            item = _step.value;
            _context.next = 10;
            return _awaitAsyncGenerator(f(item));

          case 10:
            if (!_context.sent) {
              _context.next = 13;
              break;
            }

            _context.next = 13;
            return item;

          case 13:
            _iteratorAbruptCompletion = false;
            _context.next = 4;
            break;

          case 16:
            _context.next = 22;
            break;

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](2);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 22:
            _context.prev = 22;
            _context.prev = 23;

            if (!(_iteratorAbruptCompletion && _iterator2.return != null)) {
              _context.next = 27;
              break;
            }

            _context.next = 27;
            return _awaitAsyncGenerator(_iterator2.return());

          case 27:
            _context.prev = 27;

            if (!_didIteratorError) {
              _context.next = 30;
              break;
            }

            throw _iteratorError;

          case 30:
            return _context.finish(27);

          case 31:
            return _context.finish(22);

          case 32:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 18, 22, 32], [23,, 27, 31]]);
  }));
  return _asyncSequential.apply(this, arguments);
}

function asyncConcurrent(iterable) {
  var iterator = iterable[Symbol.asyncIterator]();
  var settlementQueue = [];
  var buffer = [];
  var finished = false;
  var nextCallCount = 0;
  var resolvedCount = 0;
  var prevItem = Promise.resolve();

  function fillBuffer(concurrent) {
    var nextItem = iterator.next(concurrent);
    prevItem = prevItem.then(function () {
      return nextItem;
    }).then(function (_ref) {
      var done = _ref.done,
          value = _ref.value;

      if (done) {
        while (settlementQueue.length > 0) {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          var _settlementQueue$shif = settlementQueue.shift(),
              _settlementQueue$shif2 = _slicedToArray(_settlementQueue$shif, 1),
              resolve = _settlementQueue$shif2[0];

          resolve({
            done: true,
            value: undefined
          });
        }

        return void (finished = true);
      }

      var _value = _slicedToArray(value, 2),
          cond = _value[0],
          item = _value[1];

      if (cond) {
        buffer.push(item);
      }

      recur(concurrent);
    }).catch(function (reason) {
      finished = true;

      while (settlementQueue.length > 0) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var _settlementQueue$shif3 = settlementQueue.shift(),
            _settlementQueue$shif4 = _slicedToArray(_settlementQueue$shif3, 2),
            reject = _settlementQueue$shif4[1];

        reject(reason);
      }
    });
  }

  function consumeBuffer() {
    while (buffer.length > 0 && nextCallCount > resolvedCount) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      var value = buffer.shift(); // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

      var _settlementQueue$shif5 = settlementQueue.shift(),
          _settlementQueue$shif6 = _slicedToArray(_settlementQueue$shif5, 1),
          resolve = _settlementQueue$shif6[0];

      resolve({
        done: false,
        value: value
      });
      resolvedCount++;
    }
  }

  function recur(concurrent) {
    if (finished || nextCallCount === resolvedCount) {
      return;
    } else if (buffer.length > 0) {
      consumeBuffer();
    } else {
      fillBuffer(concurrent);
    }
  }

  return _defineProperty({
    next: function next(concurrent) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                nextCallCount++;

                if (!finished) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", {
                  done: true,
                  value: undefined
                });

              case 3:
                return _context2.abrupt("return", new Promise(function (resolve, reject) {
                  settlementQueue.push([resolve, reject]);
                  recur(concurrent);
                }));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }, Symbol.asyncIterator, function () {
    return this;
  });
}

function toFilterIterator(f, iterable) {
  var _ref3;

  var iterator = iterable[Symbol.asyncIterator]();
  return _ref3 = {}, _defineProperty(_ref3, Symbol.asyncIterator, function () {
    return this;
  }), _defineProperty(_ref3, "next", function next(_concurrent) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _yield$iterator$next, done, value;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return iterator.next(_concurrent);

            case 2:
              _yield$iterator$next = _context3.sent;
              done = _yield$iterator$next.done;
              value = _yield$iterator$next.value;

              if (!done) {
                _context3.next = 7;
                break;
              }

              return _context3.abrupt("return", {
                done: true,
                value: undefined
              });

            case 7:
              return _context3.abrupt("return", pipe1(f(value), function (cond) {
                return {
                  done: done,
                  value: [Boolean(cond), value]
                };
              }));

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }), _ref3;
}

function async(f, iterable) {
  var _iterator;

  return _defineProperty({
    next: function next(_concurrent) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (_iterator === undefined) {
                  _iterator = isConcurrent(_concurrent) ? asyncConcurrent(concurrent(_concurrent.length, toFilterIterator(f, iterable))) : asyncSequential(f, iterable);
                }

                return _context4.abrupt("return", _iterator.next(_concurrent));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }, Symbol.asyncIterator, function () {
    return this;
  });
}

function sync(f, iterable) {
  var _iterator3, _step2, a, res;

  return _regeneratorRuntime.wrap(function sync$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _iterator3 = _createForOfIteratorHelper(iterable);
          _context5.prev = 1;

          _iterator3.s();

        case 3:
          if ((_step2 = _iterator3.n()).done) {
            _context5.next = 13;
            break;
          }

          a = _step2.value;
          res = f(a);

          if (!(res instanceof Promise)) {
            _context5.next = 8;
            break;
          }

          throw new AsyncFunctionException();

        case 8:
          if (!res) {
            _context5.next = 11;
            break;
          }

          _context5.next = 11;
          return a;

        case 11:
          _context5.next = 3;
          break;

        case 13:
          _context5.next = 18;
          break;

        case 15:
          _context5.prev = 15;
          _context5.t0 = _context5["catch"](1);

          _iterator3.e(_context5.t0);

        case 18:
          _context5.prev = 18;

          _iterator3.f();

          return _context5.finish(18);

        case 21:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked, null, [[1, 15, 18, 21]]);
}

function filter(f, iterable) {
  if (iterable === undefined) {
    return function (iterable) {
      return filter(f, iterable);
    };
  }

  if (isIterable(iterable)) {
    return sync(f, iterable);
  }

  if (isAsyncIterable(iterable)) {
    return async(f, iterable);
  }

  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}

export default filter;